import { Card, styled } from "@mui/material";
import React from "react";
import { Title } from "../../../components/styled";
import BasePage from "../../BasePage";
import Header from "./components/alertsTable/Header.connected";
import AlertsTable from "./components/alertsTable/AlertsTable.connected";

const StyledCard = styled(Card)`
  background-color: #dbe4e6;
  height: auto;
  display: flex;
  border-radius: 20px;
  box-shadow: 0px 0px !important;
  padding: 25px;
  padding-right: 5px;
  overflow: auto;
`;
const StyledContainer = styled("div")`
  width: 100%;
  display: flex;
  flex-flow: column wrap;
`;

const StyledForm = styled("div")`
  max-width: 100%;
`;

const StyledOutsideContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
`;

function AlertaHistoricoPage({ nomeRoteiro }) {
  return (
    <BasePage isLoggedIn={true}>
      <Title>Histórico de Alertas</Title>
      <StyledOutsideContainer>
        <StyledForm>
          <StyledCard>
            <StyledContainer>
              <Header roteiro={nomeRoteiro} />
              <AlertsTable />
            </StyledContainer>
          </StyledCard>
        </StyledForm>
      </StyledOutsideContainer>
    </BasePage>
  );
}

export default AlertaHistoricoPage;
